/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Different_LinkInputs */

const en_faq_different_link = /** @type {(inputs: Faq_Different_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore what we build.`)
};

const lv_faq_different_link = /** @type {(inputs: Faq_Different_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apskatīt, ko mēs veidojam`)
};

/**
* | output |
* | --- |
* | "Explore what we build." |
*
* @param {Faq_Different_LinkInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_different_link = /** @type {((inputs?: Faq_Different_LinkInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Different_LinkInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_different_link(inputs)
	return en_faq_different_link(inputs)
});